import Swiper from 'swiper/bundle';

export default function initSliderArticles() {
    document.querySelectorAll(".slide-articles-container").forEach(slide => {
        let nextButton;
        let prevButton;

        const buttonsWrapper = slide.parentElement.querySelector(".slide-articles-container__buttons");
        
        if (buttonsWrapper) {
            nextButton = buttonsWrapper.querySelector(".swiper-button-next");
            prevButton = buttonsWrapper.querySelector(".swiper-button-prev");
        } else {
            nextButton = slide.querySelector(".swiper-button-next");
            prevButton = slide.querySelector(".swiper-button-prev");
        }

        new Swiper(slide, {
            slidesPerView: "auto",
            spaceBetween: 32,
            centeredSlides: true,
            grabCursor: true,
            navigation: {
                nextEl: nextButton,
                prevEl: prevButton,
            },
        });
    });
}

if (document.querySelector(".slide-articles-container")) {
    initSliderArticles();
}
